/**
 * Verbessert das Layout für Buttons innerhalb von <p>-Tags im Hauptbereich.
 * Fügt dem Elternelement die Klasse 'button-grid' hinzu.
 * Fügt 'wysiwygbutton--multiple' hinzu, wenn mehrere Buttons nebeneinander existieren.
 */
export const buttonGrid = () => {
  const buttons = Array.from(
    document.querySelectorAll("main p > a[class^='button']")
  )

  buttons.forEach(button => {
    const parentParagraph = button.parentElement
    parentParagraph.classList.add('button-grid')

    // const selectors = [
    //   'a[class*=" button"] + a[class*=" button"]',
    //   'a[class*=" button"] + a[class^="button"]',
    //   'a[class^="button"] + a[class*=" button"]',
    //   'a[class^="button"] + a[class^="button"]'
    // ];
    //
    // if (parentParagraph.querySelector(selectors.join(', '))) {
    //   parentParagraph.classList.add('button-grid--multiple');
    // }
  })
}
